import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import AuthService from '../auth.service';
import { filter, map, take } from 'rxjs';

export const isActiveGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return toObservable(authService.currentUser).pipe(
    filter((user) => user !== null),
    take(1),
    map((user) => {
      if (!user.isActive) {
        router.navigate(['/forbidden']);
        return false;
      }
      return true;
    }),
  );
};
